import {css, keyframes} from 'styled-components';

/*
 * Keyframe animations, split out of `mixins` so React Native can resolve `animations.native.ts`
 * instead. `keyframes` is not exported by the native build of styled-components, so calling it at
 * module scope makes any module that reaches this file crash Metro on import.
 *
 * Keep every export here mirrored in `animations.native.ts`.
 */

const rotate360 = keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`;

/** Rotate an element 360 degrees every "period" milliseconds, indefinitely. */
export function rotate360Animation() {
  const periodMilliseconds = 2000;
  return css`
    animation: ${rotate360} ${periodMilliseconds}ms linear infinite;
  `;
}

const shakeAnimation = keyframes`
  10%, 90% {
    transform: translateX(-1px);
  }

  20%, 80% {
    transform: translateX(2px);
  }

  30%, 50%, 70% {
    transform: translateX(-4px);
  }

  40%, 60% {
    transform: translateX(4px);
  }
`;

/** Shake effect to draw attention to a component. */
export const shakeCss = css`
  animation: ${shakeAnimation} 1s;
  transform: translateX(0px);
`;
